import { gql } from "@apollo/client";

const CREATE_ONE_TIME_PAYMENT = gql`
  mutation CreateOneTimePayment($input: CreateOneTimePaymentInput!) {
    createOneTimePayment(input: $input) {
      invoice {
        id
        status
        total
        customer
        currency
        paymentIntent {
          id
          clientSecret
          status
        }
      }
      credit {
        id
        originalAmount
      }
    }
  }
`;

export default CREATE_ONE_TIME_PAYMENT;
